







import Vue from 'vue'
import ShiftEditorEmployeeFreePlanning from '@/components/planning/shift/employee/ShiftEditorEmployeeFreePlanning.vue'
import ShiftEditorEmployeeAutomaticPlanning
  from '@/components/planning/shift/employee/ShiftEditorEmployeeAutomaticPlanning.vue'
import { EmployeeAvailableForPlanning } from '@/model/planning/EmployeeAvailableForPlanning'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import { PLANNING_ASSISTANT_GET_COMPANY_FILTER, PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM } from '@/store/getter-types'
import { CompanyFilterValue } from '@/types/payload'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { Address } from '@/model/planning/Address'
import { PlanningLookupProject } from '@/model/planning/PlanningLookupProject'

interface ComponentData {
  availableEmployeeList: EmployeeAvailableForPlanning[]
}

export default Vue.extend({
  name: 'ShiftEditorEmployee',

  components: {
    ShiftEditorEmployeeFreePlanning,
    ShiftEditorEmployeeAutomaticPlanning,
  },

  props: {
    step: String,
    editShift: Object as () => EditShiftPlan | undefined,
    projectSerieTemplate: Object as () => ShiftTemplate | undefined,
    selectedAddress: Object as () => Address | undefined,
    selectedProject: Object as () => PlanningLookupProject | null,
    isEditProject: Boolean,
  },

  data (): ComponentData {
    return {
      availableEmployeeList: []
    }
  },

  computed: {
    selectedShiftTemplateItem (): ShiftTemplate | undefined {
      return this.$store.getters[PLANNING_ASSISTANT_GET_SHIFT_TEMPLATE_ITEM]
    },

    companyFilter (): CompanyFilterValue {
      return this.$store.getters[PLANNING_ASSISTANT_GET_COMPANY_FILTER]
    },

    showAutomaticPlanning (): boolean {
      if (this.selectedShiftTemplateItem) {
        return true
      } else {
        return false
      }
    },

    showFreePlanning (): boolean {
      if (this.selectedShiftTemplateItem) {
        return false
      } else {
        return true
      }
    }
  }
})
